import { ModuleWithProviders, NgModule } from '@angular/core';
import { GaEventDirective } from './ga-event.directive';
import { GoogleImageComponent } from './google-image.component';
import { GoogleLoader } from './google-loader.service';
import { GoogleStreetViewImageComponent } from './google-street-view-image.component';
import { GoogleStreetViewImageService } from './google-street-view-image.service';
import { GoogleStreetViewInteractiveComponent } from './google-street-view-interactive.component';
import { GOOGLE_API_KEY } from './google.tokens';


export { GOOGLE_API_KEY };


export class Config {
    googleApiKey: string;
}

@NgModule({
    imports: [
        GoogleImageComponent,
        GoogleStreetViewImageComponent,
        GoogleStreetViewInteractiveComponent,
        GaEventDirective,
    ],
    providers: [
        GoogleLoader,
        GoogleStreetViewImageService,
    ],
    exports: [
        GoogleImageComponent,
        GoogleStreetViewImageComponent,
        GoogleStreetViewInteractiveComponent,
        GaEventDirective,
    ],
})
export class GoogleModule {

    static forRoot(config: Config): ModuleWithProviders<GoogleModule> {
        return {
            ngModule: GoogleModule,
            providers: [{ provide: GOOGLE_API_KEY, useValue: config.googleApiKey }],
        };
    }
}
